import { Injectable } from '@angular/core'
import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingUspComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingUspConverter extends CmsConverterService<TrainingUspComponentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      trainingId: formData.st_training_id?.value,
    }
  }
}
